/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_CHECK_PAYEE_COMPARISION = 'GET_CHECK_PAYEE_COMPARISION';
export const SET_SELECTED_INPUT_COMPARISION = 'SET_SELECTED_INPUT_COMPARISION';
export const SET_ALLOCATION_COMPARISION_DATA =
  'SET_ALLOCATION_COMPARISION_DATA';
export const IS_LOADING = 'IS_LOADING';
export const REFRESH_CHECK_ALLOCATION_COMPARISION =
  'REFRESH_CHECK_ALLOCATION_COMPARISION';
export const REFRESH_DATA_CHECK_ALLOCATION_COMPARISON_DISPLAY =
  'REFRESH_DATA_CHECK_ALLOCATION_COMPARISON_DISPLAY';
export const SET_ALL_REBATE_PROGRAM_DATA = 'SET_ALL_REBATE_PROGRAM_DATA';
